export default __webpack_public_path__ + "Content/Images/content/home-slide-2.jpg";